{
  "dataSync": {
    "sync": {
      "title": {
        "loading": "Sync",
        "personio": "Sync with Personio",
        "excel": "Sync with Excel"
      },
      "steps": {
        "structure": "Structure",
        "newPeople": "New people",
        "changes": "Changes",
        "leavers": "Leavers",
        "removals": "Removals",
        "confirm": "Confirm"
      },
      "stepsLabel": "Steps",
      "kind": {
        "departmentCreate": "New department",
        "departmentMove": "Department moved",
        "teamCreate": "New team",
        "roleCreate": "New function",
        "systemCreate": "New system",
        "unitRename": {
          "department": "Department renamed",
          "team": "Team renamed",
          "role": "Function renamed",
          "system": "System renamed"
        },
        "unitLead": {
          "department": "Department manager",
          "team": "Team lead",
          "role": "Function lead",
          "system": "System owner"
        },
        "unitDelete": {
          "department": "Delete department",
          "team": "Delete team",
          "role": "Delete function",
          "system": "Delete system"
        }
      },
      "labelled": "{{label}}: {{value}}",
      "under": "under {{name}}",
      "topLevel": "Top level",
      "field": {
        "name": "Name",
        "email": "Email",
        "department": "Department",
        "role": "Position",
        "team": "Team",
        "location": "Location"
      },
      "skipped": {
        "missingEmail": "No email"
      },
      "unsuppliedPeople_one": "{{count}} person from {{source}} cannot be added because their department, position or email is missing:",
      "unsuppliedPeople_other": "{{count}} people from {{source}} cannot be added because their department, position or email is missing:",
      "blockedReason": {
        "missingDepartment": "No department",
        "missingRole": "No position",
        "missingOwner": "No system owner",
        "nameTaken": "Name already in use",
        "emailNotChangeable": "This email cannot be changed here",
        "emailTaken": "Email already in use",
        "externalPerson": "External person",
        "actingAdmin": "Your own account",
        "lastOrgManager": "Last organization manager",
        "inUse": "Still in use",
        "personioLed": "Managed by Personio"
      },
      "waitingOn": "Selectable once its rows in these steps are selected: {{steps}}",
      "leaverReason": {
        "inactive": "inactive in Personio",
        "absentPersonio": "no longer in Personio",
        "absentExcel": "no longer in the file"
      },
      "holds": {
        "leads": "Leads {{name}}",
        "processesOwned_one": "Owner of {{count}} process",
        "processesOwned_other": "Owner of {{count}} processes",
        "processesAccountable_one": "Accountable for {{count}} process",
        "processesAccountable_other": "Accountable for {{count}} processes",
        "systemOwned": "System owner of {{name}}",
        "openAssignments_one": "{{count}} open task",
        "openAssignments_other": "{{count}} open tasks"
      },
      "usage": {
        "people_one": "{{count}} person",
        "people_other": "{{count}} people",
        "subDepartments_one": "{{count}} subdepartment",
        "subDepartments_other": "{{count}} subdepartments",
        "orgFunctions_one": "{{count}} team or function",
        "orgFunctions_other": "{{count}} teams or functions",
        "processes_one": "{{count}} process",
        "processes_other": "{{count}} processes",
        "processSteps_one": "{{count}} process step",
        "processSteps_other": "{{count}} process steps",
        "suggestions_one": "{{count}} suggestion",
        "suggestions_other": "{{count}} suggestions"
      },
      "confirm": {
        "structure": "Create or change the structure",
        "createPeople": "Create people",
        "changePeople": "Change people",
        "deletePeople": "Delete people",
        "deleteUnits": "Delete departments, teams, functions and systems",
        "deleteNamedUnits": "Delete {{units}}",
        "changeNamedLeads": "Change the lead of {{units}}",
        "noDownloadList": "This file does not come from “{{button}}”. Bliks therefore proposes no leavers and no removals."
      },
      "unitCount": {
        "department_one": "{{count}} department",
        "department_other": "{{count}} departments",
        "team_one": "{{count}} team",
        "team_other": "{{count}} teams",
        "role_one": "{{count}} function",
        "role_other": "{{count}} functions",
        "system_one": "{{count}} system",
        "system_other": "{{count}} systems"
      },
      "apply": "Apply sync",
      "applied": "Sync applied",
      "notApplied": "Not applied",
      "outcome": {
        "failed": "Failed",
        "conflict": "The value changed in Bliks since the review"
      },
      "retry": "Apply again"
    },
    "settings": {
      "title": "Data sync",
      "kind": {
        "excel": "Excel",
        "personio": "Personio"
      },
      "connections": "Connections",
      "connected": "Connected",
      "connect": "Connect",
      "uploadExcel": "Upload Excel",
      "downloadExcel": "Download Excel",
      "startSync": "Start sync",
      "changeCredentials": "Change credentials",
      "continueSync": "Continue sync",
      "unlink": "Disconnect",
      "unlinkConfirm": {
        "title": "Disconnect Personio?",
        "description": "Nothing in Bliks is deleted. You then maintain the people, departments and teams from Personio in Bliks or via Excel."
      },
      "lastSync": "Last sync: {{date}}",
      "noSyncApplied": "No sync applied yet",
      "invalidRow": "Sheet {{sheet}}, row {{row}}: {{errors}}",
      "emptyFile": "The {{sheet}} sheet contains no people.",
      "sheetRows_one": "sheet {{sheet}}, row {{rows}}",
      "sheetRows_other": "sheet {{sheet}}, rows {{rows}}",
      "missingSheets": "The file lacks sheets ({{sheets}}). Download the current file and enter your changes there.",
      "missingColumns": "Some sheets lack columns. Download the current file and enter your changes there.",
      "sheetColumns": "Sheet {{sheet}}: {{columns}}"
    },
    "personio": {
      "title": "Connect Personio",
      "replaceTitle": "Change credentials",
      "clientId": "Client ID",
      "clientSecret": "Client secret",
      "test": "Test connection",
      "testSucceeded": "The connection works.",
      "connect": "Connect",
      "instructions": {
        "step1": "In Personio, go to <bold>Settings → API credentials</bold> and click “Create custom integration” (only with a Personio plan that includes API access).",
        "step2": "Turn on read access for <bold>Employees</bold> (Bliks also reads the employments for the position with it) and allow these <bold>Readable employee attributes</bold>: ID, First name, Last name, Email, Status, Department, Team, Position, Supervisor, Workplace. Without ID, Status, Email, Department and Position, Bliks cannot add anyone.",
        "step3": "Turn on read access for <bold>Org Units</bold> (departments, teams and their leads).",
        "step3a": "For the position: turn on read access for the <bold>Job catalog</bold>.",
        "step4": "Leave <bold>Custom Reports</bold> off.",
        "step5": "Enter the Client ID and Client secret here and click “Test connection”.",
        "readOnlyNote": "Bliks only reads these fields and never writes to Personio.",
        "helpLink": "Personio help: API credentials",
        "helpUrl": "https://support.personio.de/hc/en-us/articles/4404623630993-Generate-and-manage-API-credentials"
      }
    }
  }
}
